import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { MediaInterface } from '../../../../interfaces'

@Component({
  selector: 'dmmp-horizontal-mobile-menu',
  templateUrl: './horizontal-mobile-menu.component.html'
})
export class HorizontalMobileMenuComponent implements OnInit {

  @Input() menu
  secondaryMenu
  thirdLevelMenu
  firstLevelName
  secondLevelName
  thirdLevelName
  @Input() menuItemColumn
  @Output() page = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  @Output() externalLink = new EventEmitter()
  @Input() buttons = []
  medias : MediaInterface[] = [
    {style: 'max_650x650', media: '(min-width: 326px)'},
    {style: 'max_325x325', media: '(max-width: 325px)'},
  ]

  constructor() { }

  ngOnInit(): void {
  }

  collapseOthers(currentCollapse, brothers) {
    brothers.forEach(menuItem => {
      if (menuItem.data.name !== currentCollapse.data.name) {
        menuItem.collapse = false
      }
    })
  }

}
